export const ORDER_STATUSES = {
  pending: {
    name: 'pending',
    color: "bg-yellow-100 text-yellow-800 border-yellow-200",
  },
  confirmed: {
    name: 'confirmed',
    color: "bg-indigo-100 text-indigo-800 border-indigo-300",
  },
  processing: {
    name: 'processing',
    color: "bg-blue-100 text-blue-800 border-[#0d223f]",
  },
  shipped: {
    name: 'shipped',
    color: "bg-purple-100 text-purple-800 border-purple-300",
  },
  delivered: {
    name: 'delivered',
    color: "bg-green-100 text-green-800 border-green-300",
  },
  cancelled: {
    name: 'cancelled',
    color: "bg-red-100 text-red-800 border-red-300",
  },
  refunded: {
    name: 'refunded',
    color: "bg-orange-100 text-orange-800 border-orange-300",
  },
};

// "paid" | "unpaid" | "failed" | "pending";
export const PAYMENT_STATUSES = {
  pending: {
    name: 'pending',
    color: "bg-yellow-100 text-yellow-800 border-yellow-200",
  },
  paid: {
    name: 'paid',
    color: "bg-indigo-100 text-indigo-800 border-indigo-300",
  },
 
  failed: {
    name: 'failed',
    color: "bg-red-100 text-red-800 border-red-300",
  },
  unpaid: {
    name: 'unpaid',
    color: "bg-orange-100 text-orange-800 border-orange-300",
  },
};